module.exports = __webpack_public_path__ + "static/media/fonselp.f8952650.webp";